import { sessionsStore } from '@customerio/hydra-session-state';
import { session } from '@/services/session';
import { snackbarApi } from '@/services/snackbar';
import type { NewPasswordSearch } from './new-password-search';

/** Run on arrival: without the token from the email the form can't do anything, so say why. */
export function warnMissingToken({ resetPasswordToken }: NewPasswordSearch): void {
  if (resetPasswordToken !== undefined) {
    return;
  }
  // A signed-in visitor is sent into the app instead, so the warning would only stay open over it.
  // That includes a returning visitor whose session is still being restored.
  const mayBeSignedIn =
    session.isAuthenticated.get() || (sessionsStore.get().length > 0 && !session.isInitialized.get());
  if (mayBeSignedIn) {
    return;
  }
  snackbarApi.create({
    variant: 'critical',
    id: 'resetPassword.missingResetPasswordToken',
    message:
      "You can't access this page without coming from a password reset email. If you do come from a password reset email, make sure you used the full URL provided.",
    // Zero keeps it open: the page is unusable until the visitor follows the full link.
    autoCloseTimeout: 0,
  });
}
